/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {
  constructor() {
    this.container = document.getElementById("Facet-Drawer");
    let button = document.getElementById("Facets-Toggle");

    console.log("FacetsToggle initialized");
    console.log("Button found:", button);
    console.log("Container found:", this.container);

    // Add functionality to buttons
    if (button && this.container) {
      console.log("Adding click listener to button");
      button.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("Button clicked!");
        document.getElementsByTagName("body")[0].classList.toggle("open-cc");
        this.container.classList.toggle("active");
        console.log("Container classes:", this.container.classList);
      });
    } else {
      console.error("Button or container not found!", {
        button,
        container: this.container,
      });
    }
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.openFiltersState = new Map();
    this.searchValues = new Map();

    const form = this.querySelector("form");
    console.log("🔧 FacetFiltersForm constructor", {
      element: this,
      formId: form?.id,
      formFound: !!form,
    });

    // Ne plus auto-submit sur les changements de filtres
    // Seulement pour le tri et la disponibilité en sticky bar
    this.debouncedOnSubmit = debounce((event) => {
      console.log("🔍 debouncedOnSubmit called", {
        target: event.target,
        targetId: event.target?.id,
        targetTag: event.target?.tagName,
        targetClasses: event.target?.className,
        formId: this.querySelector("form")?.id,
      });

      // Ignorer les événements provenant du champ de recherche de facettes
      if (
        event.target &&
        event.target.classList.contains("facet-search-input")
      ) {
        console.log("⚠️ Ignoring facet-search-input");
        return;
      }

      // Appliquer uniquement pour :
      // 1. Le tri (select ou input#SortBy du custom-select)
      // 2. Le checkbox de disponibilité dans la sticky bar (qui a la classe stock-ava)
      // 3. Les formulaires de la sticky bar (facets-sticky-availability-form)
      const isSelectSort = event.target && event.target.tagName === "SELECT";
      const isCustomSelectSort = event.target && event.target.id === "SortBy";
      const isStickySortOrAvailability =
        event.target &&
        (event.target.classList.contains("stock-ava") ||
          event.target.closest(".facets-sticky-availability-form"));

      console.log("✅ Conditions check:", {
        isSelectSort,
        isCustomSelectSort,
        isStickySortOrAvailability,
      });

      if (isSelectSort || isCustomSelectSort || isStickySortOrAvailability) {
        console.log("✅ Calling onSubmitHandler");
        this.onSubmitHandler(event);
      } else {
        console.log("⚠️ Not calling onSubmitHandler - conditions not met");
      }
      // Sinon, ne rien faire - on attend le clic sur "Appliquer"
    }, 500);

    form.addEventListener("input", this.debouncedOnSubmit.bind(this));
    form.addEventListener("change", this.debouncedOnSubmit.bind(this));
  }

  // Save which filters are open before re-rendering
  saveOpenStates() {
    this.openFiltersState.clear();
    document.querySelectorAll(".thb-filter").forEach((filter) => {
      const isOpen = filter.hasAttribute("open");
      const title = filter
        .querySelector(".thb-filter-title")
        ?.textContent.trim();
      if (title) {
        this.openFiltersState.set(title, isOpen);
      }
      const searchInput = filter.querySelector(".facet-search-input");
      if (searchInput && searchInput.value && searchInput.value.trim() !== "") {
        this.searchValues.set(title, searchInput.value);
      }
    });
  }

  // Restore open/closed state of filters after re-rendering
  restoreOpenStates() {
    document.querySelectorAll(".thb-filter").forEach((filter) => {
      const title = filter
        .querySelector(".thb-filter-title")
        ?.textContent.trim();
      if (title && this.openFiltersState.has(title)) {
        const shouldBeOpen = this.openFiltersState.get(title);
        if (shouldBeOpen) {
          filter.setAttribute("open", "");
        } else {
          filter.removeAttribute("open");
        }
      }
    });

    this.searchValues.forEach((searchValue, filterTitle) => {
      document.querySelectorAll(".thb-filter").forEach((filter) => {
        const title = filter
          .querySelector(".thb-filter-title")
          ?.textContent.trim();
        if (title === filterTitle) {
          const searchInput = filter.querySelector(".facet-search-input");
          if (searchInput) {
            searchInput.value = searchValue;
            // Utiliser l'instance singleton pour filtrer
            if (FacetSearch.instance) {
              FacetSearch.instance.filterOptions(searchInput);
            }
          }
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log("🚀 renderPage called with params:", searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName("thb-filter-count");

    // Save scroll position
    const scrollPosition = window.scrollY;

    const productGridContainer = document.getElementById(
      "ProductGridContainer",
    );
    if (productGridContainer) {
      const collection = productGridContainer.querySelector(".collection");
      if (collection) {
        collection.classList.add("loading");
        console.log("🔒 Loading state added to collection");
      } else {
        console.warn("⚠️ Collection element not found in ProductGridContainer");
      }
    } else {
      console.error("❌ ProductGridContainer not found!");
    }

    for (var item of container) {
      item.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      console.log("🔍 Checking cache for URL:", url);
      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        console.log("📦 Using cached data");
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        console.log("🌐 Fetching fresh data");
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    // Restore scroll position
    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 50);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log("🔄 Fetching collection data from:", url);
    fetch(url)
      .then((response) => {
        console.log("📡 Response received, status:", response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        console.log("✅ Response text received, length:", responseText.length);
        const html = responseText;

        // Vérifier que la réponse contient bien ProductGridContainer
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        const hasProductGrid = tempDiv.querySelector("#ProductGridContainer");
        console.log(
          "🔍 ProductGridContainer found in response:",
          !!hasProductGrid,
        );

        if (!hasProductGrid) {
          console.error("❌ ProductGridContainer not found in response!");
          console.log("Response preview:", html.substring(0, 500));
          throw new Error("ProductGridContainer not found in server response");
        }

        // Ajouter au cache
        FacetFiltersForm.filterData.push({ html, url });

        // Limiter à 10 entrées maximum
        const CACHE_SIZE_LIMIT = 10;
        if (FacetFiltersForm.filterData.length > CACHE_SIZE_LIMIT) {
          FacetFiltersForm.filterData.shift(); // Retirer la plus ancienne
          console.log("📦 Cache limit reached, removed oldest entry");
        }

        // Parser le HTML une seule fois pour améliorer les performances
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        console.log("🎨 Rendering filters...");
        FacetFiltersForm.renderFilters(parsedHTML, event);
        console.log("🛍️ Rendering product grid...");
        FacetFiltersForm.renderProductGridContainer(parsedHTML);
        console.log("🔢 Rendering product count...");
        FacetFiltersForm.renderProductCount(parsedHTML);

        // Mettre à jour les badges de la barre sticky
        const counts = FacetFiltersForm.extractFilterCounts(parsedHTML);
        FacetFiltersForm.updateStickyBarBadges(counts);

        console.log("✨ All rendering complete!");
        new FacetsToggle();
      })
      .catch((error) => {
        console.error("❌ Error fetching collection data:", error);
        console.error("URL that failed:", url);

        // Remove loading state in case of error
        const productGrid = document.getElementById("ProductGridContainer");
        if (productGrid) {
          const collection = productGrid.querySelector(".collection");
          if (collection) {
            collection.classList.remove("loading");
            console.log("🔓 Loading state removed from collection");
          }
        }
        const container = document.getElementsByClassName("thb-filter-count");
        for (var item of container) {
          item.classList.remove("loading");
        }

        // Show error message to user
        if (productGrid) {
          const errorDiv = document.createElement("div");
          errorDiv.className = "collection-error";
          errorDiv.style.cssText =
            "padding: 40px; text-align: center; color: #dc2626;";
          errorDiv.innerHTML =
            '<p style="font-size: 16px; font-weight: 600;">Une erreur est survenue lors du chargement des produits.</p><p style="margin-top: 10px;"><a href="' +
            window.location.pathname +
            '" style="color: #2563eb; text-decoration: underline;">Réessayer</a></p>';
          const collection = productGrid.querySelector(".collection");
          if (collection) {
            collection.innerHTML = errorDiv.outerHTML;
          }
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    // Parser le HTML une seule fois pour améliorer les performances
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    FacetFiltersForm.renderFilters(parsedHTML, event);
    FacetFiltersForm.renderProductGridContainer(parsedHTML);
    FacetFiltersForm.renderProductCount(parsedHTML);

    // Mettre à jour les badges de la barre sticky
    const counts = FacetFiltersForm.extractFilterCounts(parsedHTML);
    FacetFiltersForm.updateStickyBarBadges(counts);
  }

  static renderProductGridContainer(htmlOrParsed) {
    console.log("🔨 renderProductGridContainer called");
    const parsedHTML = typeof htmlOrParsed === 'string'
      ? new DOMParser().parseFromString(htmlOrParsed, "text/html")
      : htmlOrParsed;
    const newContent = parsedHTML.getElementById("ProductGridContainer");

    if (newContent) {
      console.log("✅ New content found, updating DOM");
      const container = document.getElementById("ProductGridContainer");
      if (container) {
        container.innerHTML = newContent.innerHTML;
        console.log("📝 DOM updated successfully");

        // Remove loading state from collection
        const collection = container.querySelector(".collection");
        if (collection) {
          collection.classList.remove("loading");
          console.log("🔓 Loading class removed from collection");
        } else {
          console.warn("⚠️ Collection element not found in updated DOM");
        }
      } else {
        console.error("❌ ProductGridContainer not found in current DOM!");
      }
    } else {
      console.error(
        "❌ New content (ProductGridContainer) not found in parsed HTML!",
      );
    }

    // Dispatcher un événement pour notifier que les produits ont été mis à jour
    window.dispatchEvent(new CustomEvent("productsRendered"));
    console.log("📢 productsRendered event dispatched");
  }

  static extractFilterCounts(parsedHTML) {
    const counts = { size: 0, mileage: 0, bikeType: 0, brand: 0 };
    const responseStickyBar = parsedHTML.querySelector('.facets-sticky-bottom');

    if (responseStickyBar) {
      // Extraire chaque comptage depuis les badges dans la réponse
      const sizeCount = responseStickyBar.querySelector('.size-count');
      const mileageCount = responseStickyBar.querySelector('.mileage-count');
      const bikeTypeCount = responseStickyBar.querySelector('.bike-type-count');
      const brandCount = responseStickyBar.querySelector('.brand-count');

      // Parser les nombres depuis le format "(1)", "(2)"
      if (sizeCount && sizeCount.textContent.trim()) {
        const match = sizeCount.textContent.match(/\((\d+)\)/);
        counts.size = match ? parseInt(match[1], 10) : 0;
      }

      if (mileageCount && mileageCount.textContent.trim()) {
        const match = mileageCount.textContent.match(/\((\d+)\)/);
        counts.mileage = match ? parseInt(match[1], 10) : 0;
      }

      if (bikeTypeCount && bikeTypeCount.textContent.trim()) {
        const match = bikeTypeCount.textContent.match(/\((\d+)\)/);
        counts.bikeType = match ? parseInt(match[1], 10) : 0;
      }

      if (brandCount && brandCount.textContent.trim()) {
        const match = brandCount.textContent.match(/\((\d+)\)/);
        counts.brand = match ? parseInt(match[1], 10) : 0;
      }
    }

    return counts;
  }

  static updateStickyBarBadges(counts) {
    const badgeConfigs = [
      { className: 'size-count', buttonSelector: '.facets-sticky-size', count: counts.size },
      { className: 'mileage-count', buttonSelector: '.facets-sticky-mileage', count: counts.mileage },
      { className: 'bike-type-count', buttonSelector: '.facets-sticky-bike-type', count: counts.bikeType },
      { className: 'brand-count', buttonSelector: '.facets-sticky-brand', count: counts.brand }
    ];

    badgeConfigs.forEach(({ className, buttonSelector, count }) => {
      const button = document.querySelector(`.facets-sticky-bottom ${buttonSelector}`);
      if (!button) return; // Le bouton n'existe pas (ex: pas de filtre de ce type)

      let badge = button.querySelector(`.${className}`);

      if (count > 0) {
        // Créer le badge s'il n'existe pas
        if (!badge) {
          badge = document.createElement('span');
          badge.className = `facets-sticky-count ${className}`;
          button.appendChild(badge);
        }
        badge.textContent = `(${count})`;
        badge.style.display = '';  // Afficher
      } else {
        // Cacher le badge s'il existe
        if (badge) {
          badge.textContent = '';
          badge.style.display = 'none';
        }
      }
    });
  }

  static renderProductCount(htmlOrParsed) {
    const parsedHTML = typeof htmlOrParsed === 'string'
      ? new DOMParser().parseFromString(htmlOrParsed, "text/html")
      : htmlOrParsed;
    const countHtml = parsedHTML.getElementById("ProductCount");
    const container = document.getElementsByClassName("thb-filter-count");

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove("loading");
      }
    }
  }

  static renderFilters(htmlOrParsed, event) {
    const parsedHTML = typeof htmlOrParsed === 'string'
      ? new DOMParser().parseFromString(htmlOrParsed, "text/html")
      : htmlOrParsed;

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row",
    );

    // Sauvegarder l'état de recherche du filtre actif avant la mise à jour
    const activeCollapsibleRow = event
      ? event.target.closest("collapsible-row")
      : null;
    let savedSearchValue = null;

    if (activeCollapsibleRow) {
      const searchInput = activeCollapsibleRow.querySelector(
        ".facet-search-input",
      );
      if (searchInput) {
        savedSearchValue = searchInput.value;
      }
    }

    // Mettre à jour TOUS les filtres (y compris celui qui vient d'être modifié)
    facetDetailsElements.forEach((element) => {
      const targetElement = document.querySelector(
        `collapsible-row[data-index="${element.dataset.index}"]`,
      );
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;

        // Synchroniser l'état checked des checkboxes (attribut HTML → propriété JS)
        targetElement
          .querySelectorAll('input[type="checkbox"]')
          .forEach((checkbox) => {
            if (checkbox.hasAttribute("checked")) {
              checkbox.checked = true;
            } else {
              checkbox.checked = false;
            }
          });
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Restore open states after rendering
    const formElement = document.querySelector("facet-filters-form");
    if (formElement && formElement.restoreOpenStates) {
      formElement.restoreOpenStates();
    }

    // Le singleton FacetSearch gère déjà les événements via délégation
    // Pas besoin de réinitialiser - les listeners fonctionnent automatiquement

    // Restaurer la valeur de recherche et filtrer APRÈS avoir attaché les listeners
    if (activeCollapsibleRow && savedSearchValue) {
      const newSearchInput = document.querySelector(
        `collapsible-row[data-index="${activeCollapsibleRow.dataset.index}"] .facet-search-input`,
      );
      if (newSearchInput) {
        newSearchInput.value = savedSearchValue;
        // Réappliquer le filtre de recherche visuellement
        const searchTerm = savedSearchValue.toLowerCase();
        const filterContent = newSearchInput.closest(".thb-filter-content");
        if (filterContent) {
          const options = filterContent.querySelectorAll(
            ".thb-filter-content-list li",
          );
          options.forEach((option) => {
            const label = option.querySelector(".filter-name");
            if (label) {
              const text = label.textContent.toLowerCase();
              if (text.includes(searchTerm)) {
                option.style.display = "";
              } else {
                option.style.display = "none";
              }
            }
          });
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-filter-count"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
      },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Save open states before submitting
    this.saveOpenStates();

    const formElement = event.target.closest("form");
    const formData = new FormData(formElement);

    // CORRECTION: S'assurer que tous les inputs des sliders sont inclus
    // Les inputs avec data-source="slider" doivent être explicitement ajoutés
    const sliderInputs = formElement.querySelectorAll(
      'input[data-source="slider"]',
    );
    sliderInputs.forEach((input) => {
      // Vérifier si la valeur n'est pas déjà dans le FormData
      const existingValues = formData.getAll(input.name);
      if (!existingValues.includes(input.value)) {
        formData.append(input.name, input.value);
      }
    });

    const searchParams = new URLSearchParams(formData);

    // Préserver les paramètres personnalisés de prix mensuel et filtre de disponibilité
    const currentUrlParams = new URLSearchParams(window.location.search);

    // Gérer le filtre de disponibilité de manière intelligente
    // Si le checkbox dans facets-bar est présent, utiliser son état
    // Sinon, vérifier le checkbox dans la sticky-bottom
    // Sinon, préserver l'état de l'URL
    const availabilityCheckboxBar = document.getElementById(
      "Filter-Availability-Bar",
    );
    const availabilityCheckboxSticky = document.querySelector(
      '.facets-sticky-availability-form input[name="filter.v.availability"]',
    );
    const availabilityCheckboxMobile = formElement.querySelector(
      'input[name="filter.v.availability"]',
    );

    // Déterminer si le filtre de disponibilité doit être actif
    let shouldHaveAvailabilityFilter = false;

    if (
      availabilityCheckboxBar &&
      availabilityCheckboxBar.form === formElement
    ) {
      // Le checkbox est dans le formulaire actuel (facets-bar), utiliser son état
      shouldHaveAvailabilityFilter = availabilityCheckboxBar.checked;
    } else if (
      availabilityCheckboxMobile &&
      availabilityCheckboxMobile.form === formElement
    ) {
      // Le checkbox est dans le formulaire mobile actuel, utiliser son état
      shouldHaveAvailabilityFilter = availabilityCheckboxMobile.checked;
    } else if (availabilityCheckboxSticky) {
      // Utiliser l'état du checkbox de la sticky-bottom
      shouldHaveAvailabilityFilter = availabilityCheckboxSticky.checked;
    } else if (currentUrlParams.has("filter.v.availability")) {
      // Préserver l'état de l'URL
      shouldHaveAvailabilityFilter = true;
    }

    // Appliquer le filtre de disponibilité si nécessaire
    if (shouldHaveAvailabilityFilter) {
      searchParams.set("filter.v.availability", "1");
    } else {
      searchParams.delete("filter.v.availability");
    }

    if (currentUrlParams.has("monthly_price_min")) {
      searchParams.set(
        "monthly_price_min",
        currentUrlParams.get("monthly_price_min"),
      );
    }
    if (currentUrlParams.has("monthly_price_max")) {
      searchParams.set(
        "monthly_price_max",
        currentUrlParams.get("monthly_price_max"),
      );
    }

    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }
    if (document.querySelector(".price_slider")) {
      if (
        searchParams.get("filter.v.price.lte") ===
        parseFloat(document.querySelector(".price_slider").dataset.max).toFixed(
          2,
        )
      ) {
        searchParams.delete("filter.v.price.lte");
      }
    }

    if (searchParams.get("filter.v.option.kilométrage.gte") === "0") {
      searchParams.delete("filter.v.option.kilométrage.gte");
    }
    if (document.querySelector(".mileage_slider")) {
      const maxMileage = parseFloat(
        document.querySelector(".mileage_slider").dataset.max,
      );
      if (
        searchParams.get("filter.v.option.kilométrage.lte") ===
        maxMileage.toString()
      ) {
        searchParams.delete("filter.v.option.kilométrage.lte");
      }
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );

    // Préserver les paramètres personnalisés de prix mensuel
    // SAUF si c'est le bouton "Effacer tout" (facets-sticky-clear)
    const isClearAllButton = event.currentTarget.classList.contains(
      "facets-sticky-clear",
    );

    if (!isClearAllButton) {
      const currentUrlParams = new URLSearchParams(window.location.search);
      const urlParams = new URLSearchParams(url);

      if (currentUrlParams.has("monthly_price_min")) {
        urlParams.set(
          "monthly_price_min",
          currentUrlParams.get("monthly_price_min"),
        );
      }
      if (currentUrlParams.has("monthly_price_max")) {
        urlParams.set(
          "monthly_price_max",
          currentUrlParams.get("monthly_price_max"),
        );
      }

      FacetFiltersForm.renderPage(urlParams.toString());
    } else {
      // Bouton "Effacer tout" - ne pas préserver les paramètres de prix mensuel
      FacetFiltersForm.renderPage(url);
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();


// Gérer le bouton "Appliquer" pour soumettre le formulaire
// Utiliser la délégation d'événements pour gérer les éléments ajoutés dynamiquement
document.addEventListener("click", function(e) {
  const applyButton = e.target.closest(".mobile-filters-apply");
  
  if (applyButton) {
    console.log("🔘 Apply button clicked via delegation!");
    e.preventDefault();
    e.stopPropagation();

    // Trouver le formulaire de filtres
    const form = document.querySelector(
      "#FacetFiltersFormMobile, #FacetFiltersForm",
    );
    if (form) {
      console.log("Form trouvé:", form.id);

      // Collecter TOUTES les valeurs des filtres cochés
      const formData = new FormData(form);
      const searchParams = new URLSearchParams();

      console.log("FormData entries:");
      // Ajouter tous les paramètres du formulaire
      for (const [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
        if (value && value.trim() !== "") {
          searchParams.append(key, value);
        }
      }

      // Ajouter les paramètres de prix mensuel si présents
      const monthlyPriceSlider = document.querySelector(
        ".monthly_price_slider",
      );
      if (monthlyPriceSlider && monthlyPriceSlider.noUiSlider) {
        const values = monthlyPriceSlider.noUiSlider.get();
        const minPrice = Math.round(parseFloat(values[0]));
        const maxPrice = Math.round(parseFloat(values[1]));

        // Ajouter seulement si différent des valeurs par défaut
        if (minPrice !== 29 || maxPrice !== 400) {
          searchParams.append("monthly_price_min", minPrice);
          searchParams.append("monthly_price_max", maxPrice);
        }
      }

      console.log("URL avant nettoyage:", searchParams.toString());

      // Nettoyer les paramètres de prix par défaut
      if (searchParams.get("filter.v.price.gte") === "0.00") {
        searchParams.delete("filter.v.price.gte");
      }
      if (document.querySelector(".price_slider")) {
        const maxPrice = parseFloat(
          document.querySelector(".price_slider").dataset.max,
        ).toFixed(2);
        if (searchParams.get("filter.v.price.lte") === maxPrice) {
          searchParams.delete("filter.v.price.lte");
        }
      }

      // Nettoyer les paramètres de kilométrage par défaut
      if (searchParams.get("filter.v.option.kilométrage.gte") === "0") {
        searchParams.delete("filter.v.option.kilométrage.gte");
      }
      if (document.querySelector(".mileage_slider")) {
        const maxMileage = parseFloat(
          document.querySelector(".mileage_slider").dataset.max,
        ).toString();
        if (
          searchParams.get("filter.v.option.kilométrage.lte") === maxMileage
        ) {
          searchParams.delete("filter.v.option.kilométrage.lte");
        }
      }

      // Préserver les filtres importants si la fonction existe
      if (typeof window.preserveImportantFilters === "function") {
        console.log("✅ Calling preserveImportantFilters");
        window.preserveImportantFilters(searchParams);
      } else {
        console.log("⚠️ preserveImportantFilters not found");
      }

      console.log("URL finale:", searchParams.toString());

      // Trouver le composant facet-filters-form et sauvegarder l'état
      const facetFiltersForm = form.closest("facet-filters-form");
      if (facetFiltersForm && facetFiltersForm.saveOpenStates) {
        facetFiltersForm.saveOpenStates();
      }

      // Appliquer les filtres via la méthode renderPage
      console.log("📤 Calling FacetFiltersForm.renderPage");
      FacetFiltersForm.renderPage(searchParams.toString(), e);

      // Fermer le drawer après application
      setTimeout(function () {
        const clickCapture = document.querySelector(".click-capture");
        if (clickCapture) {
          clickCapture.click();
        }
      }, 100);
    } else {
      console.error("❌ Form not found!");
    }
  }
});

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define("facet-remove", FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 10,
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });
    slider.noUiSlider.on("change", function (values) {
      form.querySelector("form").dispatchEvent(event);
    });
  }
}
customElements.define("price-slider", PriceSlider);

class MileageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const slider = this.querySelector(".mileage_slider");
    const amounts = this.querySelector(".mileage_slider_amount");
    const maxValue = parseFloat(slider.dataset.max);
    const paramName = this.dataset.paramName;
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");

    const mileageRanges = [
      { min: 0, max: 10, value: "< 10km" },
      { min: 10, max: 100, value: "10 - 100km" },
      { min: 100, max: 500, value: "100 - 500km" },
      { min: 500, max: 1000, value: "500 - 1000km" },
      { min: 1000, max: 2500, value: "1000 - 2500km" },
      { min: 2500, max: 5000, value: "2500 - 5000km" },
      { min: 5000, max: 10000, value: "> 5000km" },
    ];

    const args = {
      start: [
        parseFloat(slider.dataset.minValue || 0),
        parseFloat(slider.dataset.maxValue || maxValue),
      ],
      connect: true,
      step: 10,
      range: {
        min: 0,
        max: maxValue,
      },
    };

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", (values) => {
      amounts.querySelector(".field__input_min").value = Math.round(values[0]);
      amounts.querySelector(".field__input_max").value = Math.round(values[1]);
    });

    slider.noUiSlider.on("change", (values) => {
      const min = Math.round(values[0]);
      const max = Math.round(values[1]);

      const formElement = form.querySelector("form");

      // Supprimer seulement les inputs créés par le slider (pas les checkboxes manuelles)
      const sliderInputs = formElement.querySelectorAll(
        `input[name="${paramName}"][data-source="slider"]`,
      );
      sliderInputs.forEach((input) => input.remove());

      mileageRanges.forEach((range) => {
        // Vérifier si la range intersecte avec la sélection [min, max]
        // Une range est sélectionnée si elle a une intersection avec la sélection
        const rangeIntersects = range.min <= max && range.max >= min;

        if (rangeIntersects) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = paramName;
          input.value = range.value;
          input.dataset.source = "slider"; // Marquer comme venant du slider
          formElement.appendChild(input);
        }
      });

      const event = new CustomEvent("input");
      formElement.dispatchEvent(event);
    });
  }
}
customElements.define("mileage-slider", MileageSlider);

// Generic Range Slider for Autonomie, Poids, Taille, etc.
// Generic Range Slider for Autonomie, Poids, Taille, etc. avec input personnalisé pour la taille
class RangeSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slider = this.querySelector(".range_slider");
    const amounts = this.querySelector(".range_slider_amount");
    const maxValue = parseFloat(slider.dataset.max);
    const paramName = this.dataset.paramName;
    const filterType = this.dataset.filterType;
    const unit = this.dataset.unit;
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");

    // Ajouter un input personnalisé pour le filtre "taille"
    if (filterType === "taille") {
      this.addCustomTailleInput(slider, amounts, unit);
    }

    // Configuration des ranges selon le type de filtre
    // Ces valeurs doivent correspondre EXACTEMENT aux groupes créés dans Search & Discovery
    const rangeConfigs = {
      mileage: [
        { min: 0, max: 10, value: "< 10km" },
        { min: 10, max: 100, value: "10 - 100km" },
        { min: 100, max: 500, value: "100 - 500km" },
        { min: 500, max: 1000, value: "500 - 1000km" },
        { min: 1000, max: 2500, value: "1000 - 2500km" },
        { min: 2500, max: 5000, value: "2500 - 5000km" },
        { min: 5000, max: 10000, value: "> 5000km" },
      ],
      autonomie: [
        { min: 0, max: 30, value: "< 30km" },
        { min: 30, max: 50, value: "30 à 50km" },
        { min: 50, max: 70, value: "50 à 70km" },
        { min: 70, max: 80, value: "70 à +80km" },
        { min: 80, max: 150, value: "+80km" },
      ],
      poids: [
        { min: 0, max: 20, value: "< 20kg" },
        { min: 20, max: 23, value: "20 - 23kg" },
        { min: 23, max: 26, value: "23 - 26kg" },
        { min: 26, max: 30, value: "26 - 30kg" },
        { min: 30, max: 50, value: "> 30kg" },
      ],
      taille: [
        { min: 0, max: 150, value: "-150cm" },
        { min: 150, max: 160, value: "150cm - 160cm" },
        { min: 160, max: 170, value: "160cm - 170cm" },
        { min: 170, max: 180, value: "170cm - 180cm" },
        { min: 180, max: 190, value: "180cm - 190cm" },
        { min: 190, max: 250, value: "+190cm" },
      ],
    };

    const ranges = rangeConfigs[filterType] || [];

    // Déterminer le step selon le type de filtre
    let step = 1;
    if (filterType === "mileage") step = 10;
    else if (filterType === "autonomie") step = 1;
    else if (filterType === "poids") step = 1;
    else if (filterType === "taille") step = 1;

    const args = {
      start: [
        parseFloat(slider.dataset.minValue || 0),
        parseFloat(slider.dataset.maxValue || maxValue),
      ],
      connect: true,
      step: step,
      range: {
        min: 0,
        max: maxValue,
      },
    };

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    // Stocker les paramètres du slider pour réutilisation
    this.sliderData = {
      paramName,
      ranges,
      slider,
      form,
    };

    slider.noUiSlider.on("update", (values) => {
      amounts.querySelector(".field__input_min").value = Math.round(values[0]);
      amounts.querySelector(".field__input_max").value = Math.round(values[1]);
    });

    slider.noUiSlider.on("change", (values) => {
      this.updateSliderFilters(Math.round(values[0]), Math.round(values[1]));
    });
  }

  updateSliderFilters(min, max, triggerSubmit = true) {
    const { paramName, ranges, form } = this.sliderData;
    const formElement = form.querySelector("form");

    // Supprimer seulement les inputs créés par le slider pour CE paramName
    const sliderInputs = formElement.querySelectorAll(
      `input[name="${paramName}"][data-source="slider"]`,
    );
    sliderInputs.forEach((input) => input.remove());

    // Créer et ajouter les nouveaux inputs
    ranges.forEach((range) => {
      const rangeIntersects = range.min <= max && range.max >= min;

      if (rangeIntersects) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = paramName;
        input.value = range.value;
        input.dataset.source = "slider";
        input.dataset.filterType = this.dataset.filterType;
        formElement.appendChild(input);
      }
    });

    // Ne déclencher l'événement que si demandé (évite le double-trigger)
    if (triggerSubmit) {
      const event = new CustomEvent("input", { bubbles: true });
      formElement.dispatchEvent(event);
    }
  }

  addCustomTailleInput(slider, amounts, unit) {
    const wrapper = amounts.closest(".range-slider-wrapper");

    // Créer un input personnalisé pour saisir directement sa taille
    const customInputWrapper = document.createElement("div");
    customInputWrapper.className = "custom-taille-input-wrapper";
    customInputWrapper.innerHTML = `
      <div class="custom-taille-input">
        <div class="custom-taille-input-field">
          <input
            type="number"
            id="custom-taille-value"
            class="custom-taille-number"
            placeholder="175"
            min="0"
            max="250"
            step="1"
          />
          <span class="custom-taille-unit">${unit}</span>
        </div>
      </div>
    `;

    // Insérer avant le slider
    wrapper.insertBefore(customInputWrapper, wrapper.firstChild);

    // Cacher le range slider et les valeurs min/max
    const rangeSlider = wrapper.querySelector(".range_slider");
    const rangeAmounts = wrapper.querySelector(".range_slider_amount");
    const rangeHighest = wrapper.querySelector(".range-highest");
    if (rangeSlider) rangeSlider.style.display = "none";
    if (rangeAmounts) rangeAmounts.style.display = "none";
    if (rangeHighest) rangeHighest.style.display = "none";

    // Gérer l'application de la taille
    const input = customInputWrapper.querySelector("#custom-taille-value");

    // Flag pour éviter le double-trigger
    let isApplying = false;
    let debounceTimer = null;
    const self = this;

    const applyTaille = (e) => {
      if (e) e.preventDefault();
      if (isApplying) return; // Éviter les appels multiples

      const taille = parseInt(input.value);
      if (taille && taille >= 0 && taille <= 250) {
        isApplying = true;

        // Mettre à jour d'abord les filtres sans déclencher la soumission
        self.updateSliderFilters(taille, taille, false);

        // Mettre à jour le slider visuellement
        slider.noUiSlider.set([taille, taille]);

        // Déclencher la soumission après un court délai
        setTimeout(() => {
          const formElement = self.sliderData.form.querySelector("form");
          const event = new CustomEvent("input", { bubbles: true });
          formElement.dispatchEvent(event);
          isApplying = false;
        }, 100);
      }
    };

    // Appliquer automatiquement après que l'utilisateur ait fini de taper
    input.addEventListener("input", (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        applyTaille(e);
      }, 800);
    });

    input.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        clearTimeout(debounceTimer);
        applyTaille(e);
      }
    });

    // Appliquer aussi lors de la perte de focus (blur)
    input.addEventListener("blur", (e) => {
      if (input.value && input.value.trim() !== "") {
        clearTimeout(debounceTimer);
        applyTaille(e);
      }
    });
  }
}
customElements.define("range-slider", RangeSlider);

class FacetSearch {
  static instance = null;
  static initialized = false;

  constructor() {
    // Pattern singleton : retourner l'instance existante si elle existe
    if (FacetSearch.instance) {
      return FacetSearch.instance;
    }

    FacetSearch.instance = this;

    // Initialiser seulement une fois
    if (!FacetSearch.initialized) {
      this.initSearchInputs();
      FacetSearch.initialized = true;
    }

    return this;
  }

  initSearchInputs() {
    // Utiliser la délégation d'événements au niveau du document
    // Cela fonctionne même après innerHTML car on n'attache pas aux inputs directement
    const inputHandler = (e) => {
      if (e.target && e.target.classList.contains("facet-search-input")) {
        e.stopPropagation();
        this.filterOptions(e.target);
      }
    };

    const keydownHandler = (e) => {
      if (e.target && e.target.classList.contains("facet-search-input")) {
        if (e.key === "Enter") {
          e.preventDefault();
        }
      }
    };

    // Attacher les listeners au document (avec capture pour avoir priorité)
    document.addEventListener("input", inputHandler, true);
    document.addEventListener("keydown", keydownHandler, true);
  }

  filterOptions(input) {
    if (!input) return;

    const searchTerm = input.value.toLowerCase();
    const filterContent = input.closest(".thb-filter-content");

    if (!filterContent) return;

    // Chercher les <li> dans .thb-filter-content-list qui peut être dans scroll-shadow
    const options = filterContent.querySelectorAll(
      ".thb-filter-content-list li",
    );

    options.forEach((option) => {
      const label = option.querySelector(".filter-name");
      if (label) {
        const text = label.textContent.toLowerCase();
        if (text.includes(searchTerm)) {
          option.style.display = "";
        } else {
          option.style.display = "none";
        }
      }
    });
  }
}

// Custom element pour le slider de prix mensuel (collections de location)
class MonthlyPriceSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slider = this.querySelector(".monthly_price_slider");
    const amounts = this.querySelector(".monthly_price_slider_amount");

    if (!slider) return;

    const minValue = parseFloat(slider.dataset.minValue || 29);
    const maxValue = parseFloat(slider.dataset.maxValue || 400);
    const minRange = parseFloat(slider.dataset.min || 29);
    const maxRange = parseFloat(slider.dataset.max || 400);

    const args = {
      start: [minValue, maxValue],
      connect: true,
      step: 1,
      range: {
        min: minRange,
        max: maxRange,
      },
    };

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", (values) => {
      amounts.querySelector(".field__input_min").value = Math.round(values[0]);
      amounts.querySelector(".field__input_max").value = Math.round(values[1]);
    });

    // Mise à jour du compteur dans la sticky bar
    slider.noUiSlider.on("change", (values) => {
      const min = Math.round(values[0]);
      const max = Math.round(values[1]);

      if (typeof updateMonthlyPriceCount === "function") {
        updateMonthlyPriceCount(min, max);
      }
    });

    // Gérer les changements manuels dans les inputs
    const minInput = amounts.querySelector(".field__input_min");
    const maxInput = amounts.querySelector(".field__input_max");

    if (minInput && maxInput) {
      minInput.addEventListener("change", () => {
        const newMin = Math.max(
          minRange,
          Math.min(parseInt(minInput.value) || minRange, maxRange),
        );
        slider.noUiSlider.set([newMin, null]);
      });

      maxInput.addEventListener("change", () => {
        const newMax = Math.max(
          minRange,
          Math.min(parseInt(maxInput.value) || maxRange, maxRange),
        );
        slider.noUiSlider.set([null, newMax]);
      });
    }
  }
}

customElements.define("monthly-price-slider", MonthlyPriceSlider);

// Custom element pour le slider de kilométrage

window.addEventListener("load", () => {
  new FacetsToggle();
  new FacetSearch();

  // Monitor URL changes to detect if someone changes the URL without triggering renderPage
  let lastUrl = window.location.href;
  console.log("🔍 Initial URL monitoring set up:", lastUrl);

  // Check for URL changes periodically (in case history.pushState is used elsewhere)
  setInterval(() => {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      console.log("⚠️ URL changed without going through renderPage!");
      console.log("  Previous:", lastUrl);
      console.log("  Current:", currentUrl);

      // If we have filters in the URL but no renderPage call, the page might be stuck
      if (currentUrl.includes("filter.") && currentUrl !== lastUrl) {
        console.log(
          "🚨 Filter detected in URL - this might cause infinite loading!",
        );
        console.log(
          "💡 Suggestion: Ensure all filter changes go through FacetFiltersForm.renderPage()",
        );
      }

      lastUrl = currentUrl;
    }
  }, 1000);

  // Also monitor popstate events
  window.addEventListener("popstate", (event) => {
    console.log("🔙 Popstate event detected (browser back/forward)");
    console.log("  State:", event.state);
    console.log("  URL:", window.location.href);
  });
});
